/**
 * Dashboard View Store
 *
 * Manages the current view state within the main dashboard
 * Allows switching between different modules without changing routes
 */

import {create} from 'zustand';

export type DashboardViewType = 'home' | 'map' | 'analytics';

interface DashboardViewState {
  currentView: DashboardViewType;
  setCurrentView: (view: DashboardViewType) => void;
  reset: () => void;
}

export const useDashboardViewStore = create<DashboardViewState>((set) => ({
  // Initial state
  currentView: 'home',

  // Actions
  setCurrentView: (view) => set({currentView: view}),

  reset: () => set({currentView: 'home'})
}));

